import { useCallback, useState } from "react";

import { getCopyJobInput } from "../../../../evergis/core/copy/getCopyJobInput";
import { layerInfosWithDeps } from "../../../../resources/layers";
import { useAfterCopy } from "../../CopyResource/hooks/useAfterCopy";
import { JobSource, useCopyJobNotifications } from "../../CopyResource/hooks/useCopyJobNotifications";
import { useCopyResources } from "../../CopyResource/hooks/useCopyResources";
import { useSelectedResourcesNames } from "../../CopyResource/hooks/useSelectedResourcesNames";
import { useDefaultScaleRange } from "../../../../hooks/style/useDefaultScaleRange";
import { BulkCopyJob } from "../../CopyResource/types";

export const useBulkCopyLayersJob = (copyTables: boolean): BulkCopyJob => {
  const resourcesToCopy: string[] = useSelectedResourcesNames();
  const { data: resourcesInfo } = layerInfosWithDeps.use({ input: resourcesToCopy, waitInput: true });
  const { copyJob, copyData: jobResult, copyLoading: jobLoading, copyError: jobError } = useCopyResources();
  const [waiting, setWaiting] = useState(false);
  const defaultScaleRange = useDefaultScaleRange();

  const firstAlias =
    (resourcesInfo && resourcesInfo.layers.length && resourcesInfo.layers[0] && resourcesInfo.layers[0].alias) || "";
  const firstTableAlias =
    copyTables &&
    ((resourcesInfo &&
      resourcesInfo.deps.tables.length &&
      resourcesInfo.deps.tables[0] &&
      resourcesInfo.deps.tables[0].alias) ||
      "");

  const notificationInfos = useCopyJobNotifications(JobSource.BulkLayers, {
    alias: firstAlias,
    tableAlias: firstTableAlias,
    jobResult,
  });

  const { setInnerTasks } = useAfterCopy(notificationInfos, { jobResult, jobLoading, jobError }, [], false, copyTables);

  const onCopy = useCallback(async () => {
    if (!resourcesInfo) {
      return;
    }

    const [layerInput, tableInput, innerTasks] = getCopyJobInput({
      layers: resourcesInfo.layers,
      tables: resourcesInfo.deps.tables,
      copyTables,
      defaultScaleRange,
    });

    setWaiting(true);
    setInnerTasks(innerTasks);

    await copyJob({ input: [...layerInput, ...tableInput] });
  }, [resourcesInfo, copyTables, defaultScaleRange, setInnerTasks, copyJob]);

  return { onCopy, waiting };
};
